export default () => ({
  mainSwiper: null,
  thumbSwiper: null,
  slideCount: 0,

  init() {
    this.slideCount = Number(this.$el.dataset.mediaCount) || 0;
  },

  initSwipers() {
    this.thumbSwiper = new Swiper('.product-thumb-slider', {
      slidesPerView: 6,
      spaceBetween: 10,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      centerInsufficientSlides: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        320: {
          slidesPerView: 3,
        },
        750: {
          slidesPerView: 6,
        },
      },
    });

    this.mainSwiper = new Swiper('.product-main-slider', {
      slidesPerView: this.slideCount > 1 ? 1.25 : 1,
      spaceBetween: 10,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      thumbs: {
        swiper: this.thumbSwiper,
      },
      breakpoints: {
        320: {
          spaceBetween: 5,
        },
        750: {
          spaceBetween: 10,
        },
      },
    });

    // Emit event with Swiper instances
    this.$el.dispatchEvent(
      new CustomEvent('swiper:ready', {
        detail: {
          mainSwiper: this.mainSwiper,
          thumbSwiper: this.thumbSwiper,
        },
      }),
    );

    // Handle zoom modal
    document.querySelectorAll('.product__modal-opener').forEach((opener) => {
      opener.addEventListener('click', () => {
        const modal = document.querySelector(opener.dataset.modal);
        if (modal) modal.show(opener.querySelector('button'));
      });
    });

    // Add to initSwipers()
    if (window.ShopifyXR) {
      window.ShopifyXR.setupXRElements();
    }

    document.querySelectorAll('product-model').forEach((model) => {
      if (model.querySelector('model-viewer')) {
        model
          .querySelector('model-viewer')
          .addEventListener('shopify_model_viewer_ui_toggle_play', () => {
            this.mainSwiper.allowTouchMove = false;
          });

        model
          .querySelector('model-viewer')
          .addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
            this.mainSwiper.allowTouchMove = true;
          });
      }
    });
  },
});
